import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("header", {
    onMousedown: _cache[3] || (_cache[3] = (...args) => (_ctx.headerContainerMousedown && _ctx.headerContainerMousedown(...args))),
    onMouseup: _cache[4] || (_cache[4] = (...args) => (_ctx.headerContainerMouseup && _ctx.headerContainerMouseup(...args))),
    onTouchstart: _cache[5] || (_cache[5] = (...args) => (_ctx.headerContainerMousedown && _ctx.headerContainerMousedown(...args))),
    onTouchend: _cache[6] || (_cache[6] = (...args) => (_ctx.headerContainerMouseup && _ctx.headerContainerMouseup(...args))),
    class: _normalizeClass(_ctx.getClass('headerContainer') + ' ' + (!_ctx.hideHeaderCloseIFrame ? _ctx.getClass('returnToChat') : '') ),
    id: "satisfiHeaderContainer"
  }, [
    (!_ctx.hideHeaderCloseIFrame)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.headerCloseIFrameClick && _ctx.headerCloseIFrameClick(...args))),
          class: _normalizeClass(_ctx.getClass('btn') + ' ' + _ctx.getClass('closeIFrame')),
          "aria-label": "Close iframe"
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("svg", {
            width: "17",
            height: "17",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 256 512",
            "aria-hidden": "true"
          }, [
            _createElementVNode("path", {
              d: "M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z",
              fill: "#D8D8D8",
              "fill-rule": "evenodd"
            })
          ], -1 /* HOISTED */)
        ]), 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (!_ctx.hideHeaderCloseIFrame)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(_ctx.getClass('returnText')),
          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.headerCloseIFrameClick && _ctx.headerCloseIFrameClick(...args)))
        }, _toDisplayString(_ctx.backButtonLabelIFrame), 3 /* TEXT, CLASS */))
      : _createCommentVNode("v-if", true),
    ((!_ctx.hideHeader && !!_ctx.hideHeaderCloseIFrame))
      ? (_openBlock(), _createElementBlock("h1", {
          key: 2,
          class: _normalizeClass((_ctx.isHeaderImage ? _ctx.getClass('logo') : '') + ' ' +
    (_ctx.destinationURL != '' ? _ctx.getClass('logoUrl') : '')),
          onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.headerImageClick && _ctx.headerImageClick(...args)), ["stop"]))
        }, _toDisplayString(_ctx.pageTitle), 3 /* TEXT, CLASS */))
      : _createCommentVNode("v-if", true)
  ], 34 /* CLASS, NEED_HYDRATION */))
}